import { apiRequest } from "../../../../shared/lib/api";
import {
  PublicPlayerProfile,
  PublicPlayersListResponse,
} from "../types/publicPlayerProfile";

type ListPublicPlayersParams = {
  search?: string;
  category?: string;
  sex?: string;
};

export function listPublicPlayers({
  search = "",
  category = "",
  sex = "",
}: ListPublicPlayersParams = {}) {
  const params = new URLSearchParams();
  const safeSearch = String(search || "").trim();
  const safeCategory = String(category || "").trim();
  const safeSex = String(sex || "").trim();
  if (safeSearch) params.set("search", safeSearch);
  if (safeCategory) params.set("category", safeCategory);
  if (safeSex) params.set("sex", safeSex);
  const query = params.toString();
  return apiRequest<PublicPlayersListResponse>(
    `/api/public/players${query ? `?${query}` : ""}`,
  );
}

export function getPublicPlayerProfile(playerId: number) {
  return apiRequest<PublicPlayerProfile>(
    `/api/public/players/${encodeURIComponent(String(playerId))}`,
  );
}
